const testId = 'AB-004';
const variantId = 'variant-1';
const vids = [
  'https://cdn.shopify.com/videos/c/o/v/bf96572d47a94d5185e141c0e4c4947c.mp4',
  'https://cdn.shopify.com/videos/c/o/v/150c52d3ff3c4d5aad44eb55e77b7249.mp4'
];

const srcs = ['WatchCalling', 'phone.png', 'phone_1.png'];
const images = Array.from(document.querySelectorAll('.product-block .rte img'));

// Find the image that matches any of the srcs values
const makePhoneCallsImage = images.find(el => srcs.some(src => el.src.includes(src)));

// Check if the image is found before proceeding
if (makePhoneCallsImage) {
  // Create HTML for video elements
  const html = `
    <div id="${testId}-videos">
      ${vids
        .map(
          vid => `
            <video playsinline autoplay muted loop>
              <source src="${vid}" type="video/mp4">
            </video>
          `
        )
        .join('')}
    </div>
  `;

  // Insert the video HTML after the found image and hide the image
  makePhoneCallsImage.insertAdjacentHTML('afterend', html);
  makePhoneCallsImage.classList.add(`${testId}-hidden`);
  document.body.classList.add(testId);
} else {
  console.warn(`No matching image found for sources: ${srcs.join(', ')}`);
}
